// 리셉션 사이드 메뉴 (LNB)
import { paths } from '@shared/config/paths';

export const receptionSideMenu = [{ dataText: '대회/프로그램 목록', pathname: paths.reception.list.path }];

// 스캔 모드 좌측 모드 메뉴 (LNB)
export const scanModeSideMenu = [
	{ dataText: 'QR 스캔모드', mode: 'QR' as const },
	{ dataText: '직접 검색', mode: 'SEARCH' as const }
];

// 스캔 모드 상단 탭
export const scanModeTabs = [
	{ label: 'QR 스캔 모드', mode: 'QR' as const },
	{ label: '직접 검색 모드', mode: 'SEARCH' as const }
];

// 직접 검색 입력 placeholder
export const SCAN_SEARCH_PLACEHOLDER = '이름 · 전화번호 뒷4자리 · 배번';

// 리셉션 목록 테이블 헤더
export const receptionTableHeader = [
	{ label: '상태', minWidth: 95, width: 10 },
	{ label: '시작/종료 일정', minWidth: 200, width: 18 },
	{ label: '대회/프로그램 명칭', minWidth: 210, width: 20 },
	{ label: '구분', minWidth: 120, width: 11 },
	{ label: '전체 참가자', minWidth: 100, width: 10 },
	{ label: '체크인 완료', minWidth: 100, width: 10 },
	{ label: '대기중', minWidth: 90, width: 9 },
	{ label: '진행률', minWidth: 100, width: 12 }
];

// 참가자 명단 테이블 헤더 (상세)
export const receptionParticipantTableHeader = [
	{ label: '배번', minWidth: 80, width: 9 },
	{ label: '이름', minWidth: 90, width: 10 },
	{ label: '선택 코스', minWidth: 90, width: 9 },
	{ label: '전화번호', minWidth: 140, width: 14 },
	{ label: '생년월일', minWidth: 110, width: 11 },
	{ label: '상태', minWidth: 80, width: 9 },
	{ label: '체크인 일시', minWidth: 130, width: 13 },
	{ label: '담당자', minWidth: 100, width: 12 },
	{ label: '방식', minWidth: 90, width: 13 }
];

// 부스·담당자 테이블 헤더 (상세)
export const receptionStaffTableHeader = [
	{ label: '담당자명', minWidth: 120, width: 20 },
	{ label: '처리건수', minWidth: 120, width: 18 },
	{ label: 'QR처리', minWidth: 120, width: 16 },
	{ label: '수동처리', minWidth: 100, width: 16 },
	{ label: '담당자 변경 시간', minWidth: 200, width: 30 }
];

// 리셉션 목록 구분 필터 옵션
export const receptionCategoryOptions = [
	{ title: '전체', value: '' },
	{ title: '쿨밸리 TS', value: 'COOL_VALLEY_TS' },
	{ title: '장수 TS', value: 'JANGSU_TS' },
	{ title: '캠프', value: 'CAMP' }
];

// 참가자 명단 - 상태 필터 옵션
export const receiveStatusOptions = [
	{ title: '전체', value: '' },
	{ title: '수령', value: 'RECEIVED' },
	{ title: '미수령', value: 'NOT_RECEIVED' }
];

// 참가자 명단 - 코스 필터 옵션
export const receptionCourseOptions = [
	{ title: '전체', value: '' },
	{ title: '100K', value: '100K' },
	{ title: '38K-P', value: '38K-P' },
	{ title: '38K-J', value: '38K-J' },
	{ title: '25K', value: '25K' },
	{ title: '10J', value: '10J' },
	{ title: '10M', value: '10M' }
];

// 참가자 명단 - 방식 필터 옵션
export const checkInMethodOptions = [
	{ title: '전체', value: '' },
	{ title: 'QR', value: 'QR' },
	{ title: '수동처리', value: 'MANUAL' }
];

// 체크인 취소 사유 선택지
export const checkInCancelReasons = ['오처리(다른참가자)', '물품 미전달', '참가자 요청', '기타'];
